import { useQuery } from "@tanstack/react-query";

import { supabase } from "@/shared/lib/supabase";

export interface PlaceOfDeath {
  city: string | null;
  state: string | null;
  country: string | null;
}

export const placeOfDeathKey = (estateId: number | undefined) =>
  ["placeOfDeath", estateId] as const;

export async function fetchPlaceOfDeath(estateId: number): Promise<PlaceOfDeath | null> {
  const { data, error } = await supabase
    .from("entity_addresses")
    .select("addresses(city, state, country)")
    .eq("estate_id", estateId)
    .eq("purpose", "place_of_death")
    .is("valid_to", null)
    .limit(1)
    .maybeSingle();
  if (error) throw error;
  const joined = data?.addresses as PlaceOfDeath | PlaceOfDeath[] | null | undefined;
  return (Array.isArray(joined) ? joined[0] : joined) ?? null;
}

export function usePlaceOfDeath(estateId: number | undefined) {
  return useQuery({
    queryKey: placeOfDeathKey(estateId),
    queryFn: () => fetchPlaceOfDeath(estateId!),
    enabled: !!estateId,
  });
}

export const formatPlaceOfDeath = (place: PlaceOfDeath | null | undefined): string =>
  place ? [place.city, place.state, place.country].filter(Boolean).join(", ") : "";
